import * as actions from "./actions";

const tmii = [
  [106.88730736853313,-6.300661771207444], // Purna Bhakti Pertiwi Museum
  [106.88786429421816,-6.303564221211502], // Bayt Al Quran dan Museum Islam Istiqal
  [106.88867237195336,-6.303222047692529], // Museum Telekomunikasi
  [106.88894595727629,-6.304267116344491], // Museum Olah Raga
  [ 106.89195563321027,-6.302094826941854 ], // Kantor Pengelola
  [ 106.89328064401684,-6.30254804699058 ], // Anjungan DKI Jakarta
  [ 106.89582261858266,-6.3031901762380045 ], // Anjungan Jawa Tengah
  [ 106.89679089584479,-6.305605561958785 ], // Museum keprajuritan
  [ 106.90028132232715,-6.303733279601531 ], // Taman Wisata
  [ 106.9028267380387,-6.304366305573907 ], // Taman Budaya Tionghoa Indonesia
  [ 106.90292195735924,-6.3021801898129866 ], // Pusat Peragaan Ilmu Pengetahuan dan Teknologi
  [ 106.8950911973759,-6.300834499613899], // Taman Nusa
  [106.88478290421745,-6.301910640750762], // Taman Mini Indonesia Indah Main Enterance
  [106.88421530646349,-6.30202005530532] // Gerbang Masuk 1
];

const initialViewport = {
  // latitude: 39.8097343,
  // longitude: -98.5556199,
  longitude: 110.50383,
  latitude: -7.32941,
  zoom: 12
};

const initialState = {
  points: tmii.sort(() => Math.random() + 0.5),
  viewport: initialViewport,
  algorithm: "convexHull",
  delay: 100,
  evaluatingDetailLevel: 2,
  maxEvaluatingDetailLevel: 2,
  showBestPath: true,

  bestPath: [],
  bestDisplaySegments: [],
  bestCost: null,

  evaluatingPaths: [],
  evaluatingCost: null,
  running: false,
  fullSpeed: false,
  paused: false,
  startedRunningAt: null,

  pointCount: tmii.length,
  definingPoints: false,

  siteInfoOpen: false,
  algInfoOpen: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.TOGGLE_SITE_INFO_OPEN:
      return {
        ...state,
        siteInfoOpen: !state.siteInfoOpen
      };

    case actions.TOGGLE_ALG_INFO_OPEN:
      return {
        ...state,
        algInfoOpen: !state.algInfoOpen
      };

    case actions.SET_VIEWPORT_STATE:
      return {
        ...state,
        viewport: action.viewport
      };

    case actions.RESET_EVALUATING_STATE:
      return {
        ...state,
        evaluatingPaths: [],
        evaluatingCost: null
      };

    case actions.RESET_BEST_PATH_STATE:
      return {
        ...state,
        bestPath: [],
        bestCost: null
      };

      //
      // SOLVER CONTROLS
      //
    case actions.SET_ALGORITHM:
      return {
        ...state,
        ...action.defaults,
        algorithm: action.algorithm
      };

    case actions.SET_DELAY:
      return {
        ...state,
        delay: action.delay
      };

    case actions.SET_EVALUATING_DETAIL_LEVEL:
      return {
        ...state,
        evaluatingDetailLevel: action.level,
        evaluatingPaths: action.level ? state.evaluatingPaths : [],
        evaluatingCost: action.level ? state.evaluatingCost : null
      };

    case actions.SET_SHOW_BEST_PATH:
      return {
        ...state,
        showBestPath: action.show
      };

    case actions.START_SOLVING:
      return {
        ...state,
        showBestPath: false,
        running: true,
        startedRunningAt: Date.now(),
        pointCount: state.points.length
      };

    case actions.GO_FULL_SPEED:
      return {
        ...state,
        showBestPath: true,
        evaluatingDetailLevel: 0,
        evaluatingPaths: [],
        fullSpeed: true
      };

    case actions.PAUSE:
      return {
        ...state,
        paused: true,
        running: false
      };

    case actions.UNPAUSE:
      return {
        ...state,
        paused: false,
        running: true
      };

    case actions.STOP_SOLVING:
      return {
        ...state,
        points:
        state.bestPath.length > 0
          ? state.bestPath.slice(0, state.bestPath.length - 1)
          : state.points,
        showBestPath: true,
        running: false,
        paused: false,
        fullSpeed: false,
        startedRunningAt: null
      };

      //
      // SOLVER ACTIONS
      //
    case actions.SET_EVALUATING_PATHS:
      return {
        ...state,
        evaluatingPaths: state.evaluatingDetailLevel ? action.paths : [],
        evaluatingCost: state.evaluatingDetailLevel ? action.cost : null
      };

    case actions.SET_BEST_PATH:
      return {
        ...state,
        bestPath: action.path,
        bestCost: action.cost
      };

      //
      // POINT CONTROLS
      //
    case actions.SET_POINT_COUNT:
      return {
        ...state,
        pointCount: action.count
      };

    case actions.SET_POINTS:
      return {
        ...state,
        points: action.points
      };

    case actions.START_DEFINING_POINTS:
      return {
        ...state,
        points: [],
        definingPoints: true,
        pointCount: 0
      };

    case actions.ADD_DEFINED_POINT:
      return {
        ...state,
        points: [...state.points, action.point],
        pointCount: state.pointCount + 1
      };

    case actions.STOP_DEFINING_POINTS:
      return {
        ...state,
        definingPoints: false
      };

    case actions.SET_DEFAULT_MAP:
      return {
        ...state,
        viewport: initialViewport,
        points: tmii,
        pointCount: tmii.length
      };

    default:
      return state;
  }
};
